import { checkGrantsPermission, checkPermission } from '@/utils/checkPermission.js';
import { saveReloginContext } from '@/utils/reloginContext';

import { readAccessToken, readSessionRole } from './auth/tabStorage';

export const whiteList = [
  '/login',
  '/register',
  '/forgot',
  '/confirm-reset',
  '/confirm-invite',
  '/reset-password',
  '/email-confirm',
  '/404',
  '/401',
];

import { useNProgress } from '@vueuse/integrations/useNProgress';

export default function createPermission({ store, router }) {
  const { start, done } = useNProgress(null, {
    minimum: 0.1,
    speed: 200,
    trickleSpeed: 300,
    showSpinner: false,
  });

  const matched = router.resolve(location.pathname);
  const hasInitialPermission = checkPermission(matched.meta.roles, true) || checkGrantsPermission(matched.meta);

  const getFallbackRoute = (currentRole) => {
    if (currentRole === 'advertiser') {
      return '/campaigns';
    }

    const isAccessible = (path) => {
      const { meta } = router.resolve(path);
      return checkPermission(meta.roles, false) || checkGrantsPermission(meta);
    };

    return ['/dashboard', '/statistics'].find(isAccessible) ?? '/401';
  };

  if (!hasInitialPermission) {
    router.replace(getFallbackRoute(readSessionRole()));
  }

  router.beforeEach((to) => {
    start();
    store.commit('SET_PAGE_FAILURE', false);

    const entryUrl = store.state.app.entryUrl;
    if (readAccessToken()) {
      if (to.path === '/login') {
        return '/';
      }

      const currentRole = readSessionRole();
      const hasPermission = checkPermission(to.meta.roles, true) || checkGrantsPermission(to.meta);

      if (hasPermission) {
        if (entryUrl && whiteList.indexOf(entryUrl) === -1) {
          store.commit('SET_ENTRY_URL', null);
          return entryUrl;
        }
        return true;
      }

      return getFallbackRoute(currentRole);
    }

    if (whiteList.indexOf(to.path) !== -1) {
      return true;
    }

    saveReloginContext({ url: to.fullPath });
    store.commit('SET_ENTRY_URL', to.fullPath);
    return '/login';
  });

  router.afterEach(() => {
    done();
  });
}
